import { useNotification } from "@/composables/useNotification";

export function useNotifications() {
	const { success, error, warning, info, show, remove, clear, notifications } =
		useNotification();

	function showError(message: string) {
		error(message);
	}

	function showSuccess(message: string) {
		success(message);
	}

	function showWarning(message: string) {
		warning(message);
	}

	return {
		showError,
		showSuccess,
		showWarning,
		success,
		info,
		show,
		remove,
		clear,
		notifications,
	};
}
